"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormFieldStatus = function FormFieldStatus(_ref) {
  var prefix = _ref.prefix,
      disabled = _ref.disabled,
      characterCount = _ref.characterCount,
      characterLimit = _ref.characterLimit,
      helper = _ref.helper,
      validation = _ref.validation,
      shouldValidate = _ref.shouldValidate,
      valid = _ref.valid;
  var baseClass = "".concat(prefix, "form-field-status");
  var classes = (0, _classnames.default)("".concat(baseClass), disabled && "".concat(baseClass, "--disabled"), !valid && shouldValidate && "".concat(baseClass, "--error"), valid && shouldValidate && "".concat(baseClass, "--success"), characterLimit && "".concat(baseClass, "--with-character-limit"), characterCount > characterLimit && "".concat(baseClass, "--character-limit-error"));
  return _react.default.createElement("div", {
    className: classes
  }, (valid || !shouldValidate) && helper && helper.body && _react.default.createElement("div", {
    className: "".concat(baseClass, "__helper")
  }, helper.body), !valid && shouldValidate && validation && validation.body && _react.default.createElement("div", {
    className: "".concat(baseClass, "__validation")
  }, validation.body), characterLimit && _react.default.createElement("div", {
    className: "".concat(baseClass, "__character-limit")
  }, characterCount, " / ", characterLimit));
};

FormFieldStatus.defaultProps = {
  prefix: ''
};
var _default = FormFieldStatus;
exports.default = _default;